import { findIndex } from 'lodash';
import {
  CUSTOMER_TRANSACTIONS_REQUEST,
  CUSTOMER_TRANSACTIONS_REQUEST_ERROR,
  CUSTOMER_TRANSACTIONS_REQUEST_SUCCESS,
  MAIN_JOURNAL_REQUEST,
  MAIN_JOURNAL_REQUEST_ERROR,
  MAIN_JOURNAL_REQUEST_SUCCESS,
  CUSTOMER_TRANSACTION_UPDATE,
  CUSTOMER_TRANSACTION_UPDATE_ERROR,
  CUSTOMER_TRANSACTION_UPDATE_SUCCESS,
  CUSTOMER_TRANSACTION_CAPITRON_FETCH,
  CUSTOMER_TRANSACTION_CAPITRON_FETCH_SUCCESS,
  CUSTOMER_TRANSACTION_CAPITRON_FETCH_ERROR,
} from '@/store/actions/journal';
import { handleRequestError } from '@/utils/error';

import Repository, { JOURNALS } from '@/repositories/RepositoryFactory';

const JournalsRepository = Repository.get(JOURNALS);

const state = {
  customerTransactions: [],
  customerTransactionsMeta: '',
  customerTransactionsStatus: '',
  customerTransactionUpdateStatus: '',
  capitronStatementsStatus: '',
  mainJournal: [],
  mainJournalStatus: '',
  mainJournalMeta: '',
};

const getters = {
  customerTransactions: state => state.customerTransactions,
  customerTransactionsMeta: state => state.customerTransactionsMeta,
  customerTransactionsStatus: state => state.customerTransactionsStatus,
  customerTransactionUpdateStatus: state => state.customerTransactionUpdateStatus,
  capitronStatementsStatus: state => state.capitronStatementsStatus,
  mainJournal: state => state.mainJournal,
  mainJournalStatus: state => state.mainJournalStatus,
  mainJournalMeta: state => state.mainJournalMeta,
};

const actions = {
  [CUSTOMER_TRANSACTIONS_REQUEST]: async ({ commit }, payload) => {
    commit(CUSTOMER_TRANSACTIONS_REQUEST);
    try {
      const response = await JournalsRepository.getCustomerTransactions(payload);
      commit(CUSTOMER_TRANSACTIONS_REQUEST_SUCCESS, response.data);
    } catch (error) {
      commit(CUSTOMER_TRANSACTIONS_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [CUSTOMER_TRANSACTION_CAPITRON_FETCH]: async ({ commit }, payload) => {
    commit(CUSTOMER_TRANSACTION_CAPITRON_FETCH);
    try {
      const response = await JournalsRepository.postCapitronStatements(payload);
      commit(CUSTOMER_TRANSACTION_CAPITRON_FETCH_SUCCESS, response.data);
      return response.data;
    } catch (error) {
      commit(CUSTOMER_TRANSACTION_CAPITRON_FETCH_ERROR);
      handleRequestError(error);
      throw error;
    }
  },
  [CUSTOMER_TRANSACTION_UPDATE]: async ({ commit }, payload) => {
    commit(CUSTOMER_TRANSACTION_UPDATE);
    try {
      const response = await JournalsRepository.updateCustomerTransaction(
        payload.transactionId,
        payload.data
      );
      commit(CUSTOMER_TRANSACTION_UPDATE_SUCCESS, response.data.data);
    } catch (error) {
      commit(CUSTOMER_TRANSACTION_UPDATE_ERROR);
      handleRequestError(error);
    }
  },
  [MAIN_JOURNAL_REQUEST]: async ({ commit }, payload) => {
    commit(MAIN_JOURNAL_REQUEST);
    try {
      const response = await JournalsRepository.getMainJournal(payload);
      commit(MAIN_JOURNAL_REQUEST_SUCCESS, response.data);
    } catch (error) {
      commit(MAIN_JOURNAL_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
};

const mutations = {
  [CUSTOMER_TRANSACTIONS_REQUEST]: state => {
    state.customerTransactionsStatus = 'loading';
  },
  [CUSTOMER_TRANSACTIONS_REQUEST_SUCCESS]: (state, payload) => {
    state.customerTransactionsStatus = 'success';
    state.customerTransactions = payload.data;
    state.customerTransactionsMeta = payload.meta;
  },
  [CUSTOMER_TRANSACTIONS_REQUEST_ERROR]: state => {
    state.customerTransactionsStatus = 'error';
  },
  [CUSTOMER_TRANSACTION_UPDATE]: state => {
    state.customerTransactionUpdateStatus = 'loading';
  },
  [CUSTOMER_TRANSACTION_UPDATE_SUCCESS]: (state, payload) => {
    state.customerTransactionUpdateStatus = 'success';
    if (payload?.id) {
      const index = findIndex(state.customerTransactions, { id: payload.id });
      state.customerTransactions[index] = payload;
    }
  },
  [CUSTOMER_TRANSACTION_UPDATE_ERROR]: state => {
    state.customerTransactionUpdateStatus = 'error';
  },
  [CUSTOMER_TRANSACTION_CAPITRON_FETCH]: state => {
    state.capitronStatementsStatus = 'loading';
  },
  [CUSTOMER_TRANSACTION_CAPITRON_FETCH_SUCCESS]: state => {
    state.capitronStatementsStatus = 'success';
  },
  [CUSTOMER_TRANSACTION_CAPITRON_FETCH_ERROR]: state => {
    state.capitronStatementsStatus = 'error';
  },
  [MAIN_JOURNAL_REQUEST]: state => {
    state.mainJournalStatus = 'loading';
  },
  [MAIN_JOURNAL_REQUEST_SUCCESS]: (state, payload) => {
    state.mainJournalStatus = 'success';
    state.mainJournal = payload.data;
    state.mainJournalMeta = payload.meta;
  },
  [MAIN_JOURNAL_REQUEST_ERROR]: state => {
    state.mainJournalStatus = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
